export const PERSONALITY_QUESTION = 'What do you consider yourself?'

export const PERSONALITY_OPTIONS = [
  { key: 'introvert', i18nKey: 'introvert' },
  { key: 'extrovert', i18nKey: 'extrovert' },
  { key: 'mixOfBoth', i18nKey: 'mixOfBoth' },
] as const
